var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3C22 1.34315 20.6569 0 19 0H3C1.34315 0 0 1.34315 0 3V19C0 20.6569 1.34315 22 3 22H19C20.6569 22 22 20.6569 22 19V3ZM20 3C20 2.44772 19.5523 2 19 2H3C2.44772 2 2 2.44772 2 3V19C2 19.5523 2.44772 20 3 20H19C19.5523 20 20 19.5523 20 19V3Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7C15 9.20914 13.2091 11 11 11C8.79086 11 7 9.20914 7 7C7 4.79086 8.79086 3 11 3C13.2091 3 15 4.79086 15 7ZM8.97716 7C8.97716 8.11719 9.88281 9.02284 11 9.02284C12.1172 9.02284 13.0228 8.11719 13.0228 7C13.0228 5.88281 12.1172 4.97716 11 4.97716C9.88281 4.97716 8.97716 5.88281 8.97716 7Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.39909 15.6808C5.49015 12.8286 8.47114 12 11 12C13.5289 12 16.5099 12.8286 17.6009 15.6808C17.9505 16.5948 17.6826 17.4756 17.1363 18.0778C16.6103 18.6576 15.8215 19 15 19H7C6.17849 19 5.38973 18.6576 4.86372 18.0778C4.31737 17.4756 4.04947 16.5948 4.39909 15.6808ZM11 14C8.72346 14 6.89905 14.7433 6.26709 16.3954C6.21826 16.523 6.25506 16.6349 6.34496 16.734C6.47492 16.8772 6.71694 17 7 17H15C15.2831 17 15.5251 16.8772 15.655 16.734C15.7449 16.6349 15.7817 16.523 15.7329 16.3954C15.101 14.7433 13.2765 14 11 14Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.02a885315b5fd2c9026ee88f6aacd102.svg";
export { ForwardRef as ReactComponent };